module.exports = __webpack_public_path__ + "img/pengajuan-isbn-internal.b7fa5d8d.jpeg";